import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import vuetify from './plugins/vuetify'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'
import './plugins/vuetify-money.js'
import Toasted from 'vue-toasted'
import VueMeta from 'vue-meta'
import 'animate.css'
import Eagle, { Slide, Transition } from 'eagle.js'
import './quasar'
import '@/styles/main.scss'
import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective)

Vue.use(Eagle)
Vue.component('Slide', Slide)
Vue.component(Transition.name, Transition)

Vue.config.productionTip = false
Vue.use(vuetify)
Vue.use(VueTelInputVuetify, {
  vuetify
})
Vue.use(VueMeta)

Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 3000
})

Vue.directive('click-outside', {
  bind () {
    this.event = event => this.vm.$emit(this.expression, event)
    this.el.addEventListener('click', this.stopProp)
    document.body.addEventListener('click', this.event)
  },
  unbind() {
    this.el.removeEventListener('click', this.stopProp)
    document.body.removeEventListener('click', this.event)
  },

  stopProp(event) { event.stopPropagation() }
})

Vue.prototype.$getRight = rightName => store.getters['user/getUserRight'](rightName)
Vue.prototype.$publicPath = location.origin
Vue.prototype.$showError = (title, message) => {
  store.dispatch('showSubmitFormErrorPopup', {
    title: title,
    message: message
  })
}
Vue.prototype.$checkEqualityStrings = (str1, str2) => {
  if (typeof str1 === 'string' && typeof str2 === 'string') {
    return str1.toLowerCase() === str2.toLowerCase()
  } else {
    return false
  }
}

const vm = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')

global.vm = vm
